export const DeliveryTime = ({delivery_details = ""}) => {
  if(!delivery_details) return <div></div>;
  return <p class="flex items-center text-[10px] font-semibold text-gray-500">🚚 {delivery_details}</p>;
};
